import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ContentQueryParams } from "./Contents";
import { EventQueryParams } from "./Events";
import { GuideQueryParams } from "./Guides";
import { ItineraryQueryParams } from "./Itineraries";
import { ListingQueryParams } from "./Listings";
import { fetchQueryFunction } from "./queries";
import { RegionQueryParams } from "./Regions";

export type Tag = {
  id: number;
  category: string;
  note: string;
  name: string;
  show?: boolean;
  tagging_count: number;
  tag_id: number;
};

export type TagFilterParams = {
  id?: number | number[];
  category?: string | string[];
  name?: string | string[];
};

export type TagCountResult = {
  id: number;
  name: string;
  count: number;
  show: boolean;
};
export type TagList = Record<string, TagCountResult[]>;
export type FilterTagWithChecked = Record<
  string,
  Array<TagCountResult & { checked: boolean }>
>;

export type TagQueryParams = {
  events: EventQueryParams;
  guides: GuideQueryParams;
  listings: ListingQueryParams;
  itineraries: ItineraryQueryParams;
  contents: ContentQueryParams;
  regions: RegionQueryParams;
};

export const fetchTags = <T extends keyof TagQueryParams>(
  resource?: T,
  params?: TagQueryParams[T],
) =>
  fetchQueryFunction<TagQueryParams[T], TagList>({
    path: `${resource}/tags`,
    resource: ["tags", resource],
    params,
  });

export const useTags = <T extends keyof TagQueryParams>(
  resource?: T,
  params?: TagQueryParams[T] & { hide_empty?: boolean },
  options?: Omit<UseQueryOptions<TagList, Error>, "queryKey" | "queryFn">,
) =>
  useQuery<TagList, Error>({
    queryKey: ["tags", resource, params],
    queryFn: () => fetchTags(resource, params),
    ...options,
  });
